"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zoomRatioReducer = void 0;
var zoomRatioReducer = function (state, action) {
    switch (action.op) {
        case 'reset':
            return 1;
        case 'set':
            return Math.max(1, action.value);
        case 'update':
            return Math.max(1, state * action.delta);
    }
};
exports.zoomRatioReducer = zoomRatioReducer;
